import React from 'react'
import Title from 'antd/es/typography/Title'
import { Flex, Card, Space, Tag } from 'antd'
import MarkdownRenderer from '../../../../../../../../../components/common/markdown-renderer'
import TextDiffViewer from '../../../../../../section-menu/rubric-refinement/chat/messages/DiffViewer'

const Guidelines = ({ question, questionRubric }) => {
    // Use rubric-level grading reference content from enriched data
    const gradingReferenceContent = questionRubric?.rubric?.gradingReferenceContent
    const comparisonGradingReference = question?.comparisonGradingReference
    
    const hasComparisonReference = comparisonGradingReference && 
        String(comparisonGradingReference).trim() !== ''
    const hasCurrentReference = gradingReferenceContent && 
        String(gradingReferenceContent).trim() !== ''

    const renderDiffView = () => {
        if (hasComparisonReference) {
            const current = String(gradingReferenceContent || '')
            const comparison = String(comparisonGradingReference || '')
            const isFinalized = question.gradingReferenceChangeStatus === 'Done' || question.gradingReferenceChangeStatus === 'finalized'
            // Finalized: comparison (left) vs current (right)
            // Pending: current (left) vs comparison (right)
            const leftValue = isFinalized ? comparison : current
            const rightValue = isFinalized ? current : comparison
            
            return (
                <Card size='small'>
                    <Space direction='vertical' style={{ width: '100%' }} size='middle'>
                        <Space>
                            <Title level={2} style={{ fontSize: '1rem', margin: 0 }}>
                                Grading reference content
                            </Title>
                            {question?.gradingReferenceChangeStatus && (
                                <Tag color={question.gradingReferenceChangeStatus === 'pending' ? 'orange' : 'green'}>
                                    {question.gradingReferenceChangeStatus === 'pending' ? 'Pending' : 'Finalized'}
                                </Tag>
                            )}
                        </Space>
                        <TextDiffViewer 
                            oldValue={leftValue} 
                            newValue={rightValue} 
                            showDiff={true} 
                        />
                    </Space>
                </Card>
            )
        } else if (hasCurrentReference) {
            return (
                <div>
                    <Title level={2} style={{ fontSize: '1rem', margin: 0, marginRight: 8 }}>
                        AI Grading Reference
                    </Title>
                    <MarkdownRenderer content={gradingReferenceContent} />
                </div>
            )
        }
        return null
    }

    return (
        <Flex vertical gap={16}>
            {renderDiffView()}
        </Flex>
    )
}

export default Guidelines
